interface PageInfo {
	url: string;
	timeStamp: number;
	referrer: string;
	apiDomains: string[];
	customInfo: any;
}

export default class PageInfoManager {
	private url: string;
	private timeStamp: number;
	private referrer: string;
	private apiDomains: string[];
	private customInfo: any;
	constructor () {
		this.url = window && window.location && window.location.href;
		this.timeStamp = Date.now();
		this.referrer = document && document.referrer;
		this.apiDomains = [];
	}
	/**
	 * 设置自定义信息，自定义信息会一起上报至 Cat
	 * @param info 自定义信息
	 */
	setCustomInfo (info: any): void {
		this.customInfo = info;
	}
	/**
	 * 获取当前页面 url 信息
	 */
	getPageInfo (): PageInfo {
		return {
			url: this.url,
			timeStamp: this.timeStamp,
			referrer: this.referrer,
			apiDomains: this.apiDomains,
			customInfo: this.customInfo
		};
	}
}
